import { Link, Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { api, errMessage } from "../lib/api";
import { Loader } from "./Bits";

export const RequireAuth = ({ children, admin = false }) => {
  const { user } = useAuth();
  const loc = useLocation();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to={`/signin?next=${encodeURIComponent(loc.pathname + loc.search)}`} replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

export const resendVerification = async () => {
  try {
    const { data } = await api.post("/auth/resend-verification");
    toast.success(data.message);
  } catch (e) {
    toast.error(errMessage(e));
  }
};

export const VerifyBanner = () => {
  const { user } = useAuth();
  if (!user || user.email_verified) return null;
  return (
    <div role="status" data-testid="verify-banner" style={{ background: "#fff4d6", color: "#6b4a00", borderBottom: "1px solid #f1dfa6" }}>
      <div className="wrap-md" style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: "6px 14px", minHeight: 48, fontSize: 14 }}>
        <span><strong>Confirm your email</strong> to like proposals and submit your own. We sent a link to {user.email}.</span>
        <button type="button" className="btn-link" style={{ color: "#6b4a00" }} onClick={resendVerification} data-testid="verify-resend-btn">
          Send it again
        </button>
      </div>
    </div>
  );
};

export const signInPath = (next) => `/signin?next=${encodeURIComponent(next || window.location.pathname)}`;

export const SignInLink = ({ children = "Sign in", next }) => <Link to={signInPath(next)}>{children}</Link>;
